var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-info',{ref:"barInfo"}),_c('cloud-note',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.query.isSelf!=2),expression:"$route.query.isSelf!=2"}],ref:"cloudNote"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }